import { Component, OnDestroy, OnInit } from '@angular/core';
import { Globals } from '../../../services/globals.service';
import { BaseComponent } from '../../../classes/base-component';
import { TILE_TYPE, TileService } from '../../../services/tile.service';
import { TrackAnalyticsService } from '../../../services/track-analytics.service';
import { TodayDataProviderService } from '../../../services/data-provider/today-data-provider.service';
import { ViewState } from '../../../shared/enums/view-state.enum';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-today-tile',
    templateUrl: './today-tile.component.html',
    styleUrls: ['./today-tile.component.scss'],
    viewProviders: [],
    providers: [Globals],
})
export class TodayTileComponent extends BaseComponent implements OnInit, OnDestroy {
    private readonly type: TILE_TYPE = TILE_TYPE.TODAY;
    LABELS;
    protected readonly ViewState = ViewState;

    todayTileData$ = this.todayDataProvider.todayTileData$;

    constructor(
        private globals: Globals,
        private analytics: TrackAnalyticsService,
        private tiles: TileService,
        private todayDataProvider: TodayDataProviderService,
        private translate: TranslateService
    ) {
        super();
    }

    ngOnInit() {
        this.todayDataProvider.startContinuousTileDataUpdate();
        this.translate.get('screens.dashboard.consumptionAlert.stats').subscribe((texts: any) => {
            this.LABELS = texts;
        });
    }

    ngOnDestroy() {
        super.ngOnDestroy();
        this.todayDataProvider.killTileSub();
    }

    onTileClicked(): void {
        this.detailEntered();
        this.tiles.openDetailView(this.type);
    }

    /*
     * Analytic stuff
     * =============================================================================================
     */
    private detailEntered() {
        if (!this.globals.getFirstDetailsViewed()) {
            this.trackFirstDetailView();
        }
        this.globals.setFirstDetailsViews();
        this.trackDetailsEntered();
    }

    private trackDetailsEntered(): void {
        this.analytics.trackEvent({
            action: 'dashboard_tile_tapped',
            properties: {
                category: 'Tiles',
                label: 'Tile: Today',
            },
        });
    }

    private trackFirstDetailView(): void {
        // Erstes aufrufen eines Detail Screens
        this.analytics.trackEvent({
            action: 'first_detail_view',
            properties: {
                category: 'Screens',
                label: 'Screen: Today-Details',
            },
        });
    }
}
